import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import { Typography } from '@cobliteam/ui/components';
import Card, { CardContent } from '@cobliteam/ui/components/Card';
import { format } from '@cobliteam/utils/date';
import { cobliLogoSvg } from '../../assets';

const UserData = () => {
  const { getSession, getUser } = useUser();
  const { fleet } = getSession();
  const { id, name, email, role, creationDate } = getUser();

  const isCobler = role === 'cobler';

  return (
    <div className='flex flex-col gap-2'>
      <Typography variant='heading-1' color='default'>
        Meus Dados
      </Typography>
      {isCobler && (
        <div className='flex items-center gap-2 py-4 text-red-500'>
          <img src={cobliLogoSvg} className='size-10' />
          <Typography variant='body'>
            <strong>Você é um Cobler!</strong>
          </Typography>
        </div>
      )}
      <Card>
        <CardContent className='flex flex-col gap-2'>
          <Typography variant='body'>
            <strong>ID:</strong> {id}
          </Typography>
          <Typography variant='body'>
            <strong>Nome:</strong> {name}
          </Typography>
          <Typography variant='body'>
            <strong>Email:</strong> {email}
          </Typography>
          <Typography variant='body'>
            <strong>Role:</strong> {role}
          </Typography>
          <Typography variant='body'>
            <strong>Fleet ID:</strong> {fleet.id}
          </Typography>
          <Typography variant='body'>
            <strong>Fleet Name:</strong> {fleet.name}
          </Typography>
          <Typography variant='body'>
            <strong>Conta criada em:</strong> {format(creationDate || new Date(), 'dd/MM/yyyy')}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default UserData;
